import React, { useState } from 'react';

import * as S from './styles';
import './order-detail-progress-style.scss';
import { IProps } from './types';
import { OrderStatus, PaymentChargeStatusEnum } from '../../../../__generated__/globalTypes';
import CreditCardImg from '@src/imagesNew/icons/credit-card.png';
import SecurityShieldImg from '@src/imagesNew/icons/security-shield.png';
import iconOrderInTransit from './images/icon-in-transit.png';
import iconOrderDelivered from './images/icon-delivered.png';
import { Button, Col, Row } from 'react-bootstrap';
import { OrderStatusBar } from '@src/components/molecules';
import { KycConfirmRequestModal } from '@atoms/KycConfirmRequestModal';

const OrderDetailProgress: React.FC<IProps> = ({ orderByToken, handlePayment, handleCancelOrder }: IProps) => {
  const { status: orderStatus, paymentStatus, fulfillments } = orderByToken;
  const [showKycConfirmRequestModal, setShowKycConfirmRequestModal] = useState(false);

  // https://github.com/velymonkeys/velymonkeys/blob/74c6d7da82ed9a4b51f9973f34e27d728b5e6a8f/saleor/mp_order/views.py#L65
  const isDelivered = fulfillments.reduce((acc, curr) => {
    return acc && curr.status === 'DELIVERED';
  }, true);

  const handleClickGuideline = () => {
    window.open('about:blank').location.href = 'https://maccaron.in/en/page/mgs_kyc_guideline/';
  };

  const handleRequestKycConfirm = async (e: any) => {
    if (e) {
      e.preventDefault();
    }
    setShowKycConfirmRequestModal(true);
  };
  const handleRequestKycConfirmModalClose = () => {
    setShowKycConfirmRequestModal(false);
  };

  const handleKycVerification = (e: any, kycUrl) => {
    if (e) {
      e.preventDefault();
    }

    window.open(kycUrl, '_blank');
  };

  const renderProgress = (orderStatus: OrderStatus, paymentStatus: PaymentChargeStatusEnum) => {
    if (orderByToken.isMgs && paymentStatus === 'NOT_CHARGED') {
      return (
        <>
          <S.Title>Waiting for payment!</S.Title>
          <S.ImageIcon src={CreditCardImg} />
          <br />
          {/*<S.Content>*/}
          {/*  KYC has been successfully completed.*/}
          {/*</S.Content>*/}
          {/*<S.Content>*/}
          {/*  Good deals don’t last forever.<br/>*/}
          {/*  Make your payment ASAP before you lose them!*/}
          {/*</S.Content>*/}
          <Button onClick={(e: any) => handlePayment(e)}>PAY NOW {'>'}</Button>
          <S.P onClick={(e: any) => handleCancelOrder(e)} style={{ margin: '1.5rem' }}>
            Or want to cancel?
          </S.P>
        </>
      );
    } else if (orderByToken.isMgs && !orderByToken.isKycChecked) {
      return (
        <>
          {orderByToken?.kycUrl ? (
            <>
              <S.ImageIcon src={SecurityShieldImg} />

              <div style={{ padding: '16px' }}>
                <S.Title>Waiting for KYC!</S.Title>
                <S.Content>KYC Verification required to Process Shipment</S.Content>
                <S.Content>
                  As per the regulations of the Government of India, KYC is mandatory for global sales products.
                </S.Content>
                <S.Content>To proceed with the shipment, please submit your KYC details.</S.Content>
              </div>
            </>
          ) : (
            <>
              <S.ImageIcon src={SecurityShieldImg} />
              <div style={{ padding: '16px' }}>
                <S.Title>Oops, something went wrong!</S.Title>
                <S.Content>
                  To proceed with the shipment, KYC verification is required. However, there is currently an error
                  preventing access to the verification link.
                </S.Content>
                <S.Content>
                  Please try refreshing the page or returning to the previous page to attempt the action again after
                  some time.
                </S.Content>
                <S.Content>If this problem persists, please contact us for further assistance.</S.Content>
              </div>
            </>
          )}
          <Row>
            <Col>
              <Button
                className="kyc-verification-btn"
                disabled={orderByToken?.kycUrl ? false : true}
                onClick={(e: any) => handleKycVerification(e, orderByToken?.kycUrl)}
              >
                KYC Verification
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <button
                onClick={handleClickGuideline}
                style={{ color: '#fd346a', borderColor: '#fd346a', zIndex: 1, margin: '2rem' }}
                className="btn btn-outline"
                // disabled={loadingResult}
              >
                See Guideline
              </button>
            </Col>
          </Row>
          {/* <S.P onClick={(e: any) => handleRequestKycConfirm(e,)}>
            Already submitted?
          </S.P>
          <KycConfirmRequestModal show={showKycConfirmRequestModal} onHide={handleRequestKycConfirmModalClose} orderId={orderByToken.id} />
          <S.P onClick={(e: any) => handleCancelOrder(e,)}>
            Or want to cancel?
          </S.P> */}
        </>
      );
    } else if (orderStatus !== 'CANCELED') {
      if (paymentStatus === 'NOT_CHARGED') {
        return (
          <>
            <S.Title>Your order has been created!</S.Title>
            <S.Content>
              Good deals don't last forever.
              <br />
              Make your payment ASAP before you lose them!
            </S.Content>
            <S.ImageIcon src={CreditCardImg} />
            <br />
            <Button onClick={(e: any) => handlePayment(e)}>PAY NOW {'>'}</Button>
            <S.P onClick={(e: any) => handleCancelOrder(e)} style={{ margin: '1.5rem' }}>
              Or want to cancel?
            </S.P>
          </>
        );
      } else {
        if (orderStatus === 'UNFULFILLED') {
          return <OrderStatusBar orderStatus={orderStatus} />;
        } else if (orderStatus === 'WAITING_FOR_PICKUP') {
          return <OrderStatusBar orderStatus={orderStatus} />;
        } else if (orderStatus === 'FULFILLED') {
          if (!isDelivered) {
            return (
              <>
                <S.Title>New skin coming your way</S.Title>
                <S.ImageIcon src={iconOrderInTransit} />
              </>
            );
          } else {
            return (
              <>
                <S.Title>Delivered at your doorstep!</S.Title>
                <S.ImageIcon src={iconOrderDelivered} />
              </>
            );
          }
        }
      }
    }
  };

  return <S.Wrapper>{renderProgress(orderStatus, paymentStatus)}</S.Wrapper>;
};

export { OrderDetailProgress };
